export default "__VITE_ASSET__DuRY65m$__"